import React from 'react';
import * as Styled from './SecondaryNav.styles';
export default function SecondaryNavItem({ item, changeTab, active, index, }) {
    return (React.createElement(Styled.Tab, { startIcon: item.icon, active: `${active}`, key: index, onClick: changeTab(index), "data-cy": item.cy, disabled: item.disabled && !item.disabledMessage }, item.title));
}
